import { render } from "./InviteLinkForm.vue?vue&type=template&id=3f46bd60&scoped=true"
import script from "./InviteLinkForm.vue?vue&type=script&lang=js"
export * from "./InviteLinkForm.vue?vue&type=script&lang=js"

import "./InviteLinkForm.vue?vue&type=style&index=0&id=3f46bd60&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f46bd60"]])

export default __exports__